import type { JsonSchema, NestedObject, UISchemaElement } from '@restore/reform';
import { baseApiUrl } from 'src/config';
import { getAccessToken } from 'src/routes/AuthContext';

export type ReformFormType =
  | 'DAILY_SOAP_NOTE_REFORM'
  | 'DISCHARGE_REFORM_OT'
  | 'DISCHARGE_REFORM_PT'
  | 'DISCHARGE_REFORM_SLP'
  | 'EVALUATION_REFORM_OT'
  | 'EVALUATION_REFORM_PT'
  | 'EVALUATION_REFORM_SLP'
  | 'WEEKLY_PROGRESS_NOTE_REFORM_OT'
  | 'WEEKLY_PROGRESS_NOTE_REFORM_PT'
  | 'WEEKLY_PROGRESS_NOTE_REFORM_SLP'
  | 'RECERTIFICATION_REFORM_OT'
  | 'RECERTIFICATION_REFORM_PT'
  | 'RECERTIFICATION_REFORM_SLP';

export type ReformJsonSchema = JsonSchema & {
  formType: ReformFormType;
  version: string;
  enterprise: string;
};

export type ReformUISchema = UISchemaElement & {
  formType: ReformFormType;
  version: string;
  enterprise: string;
};

export type SchemaResponse = {
  data: NestedObject;
  schema: ReformJsonSchema;
  uiSchema: ReformUISchema;
  error: false | string;
};

export const getSchema = async (
  realm: string,
  formId: string,
  uuid: string
): Promise<SchemaResponse> => {
  const formData = new FormData();
  const token = await getAccessToken();

  formData.append('webhookUuid', uuid);

  return fetch(`${baseApiUrl}/document/form/json/get/${formId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': realm,
    },
    body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((fieldData) => {
      return {
        ...fieldData.data,
        error: fieldData.code === 'OK' ? false : fieldData.message,
      };
    })
    .catch((error) => {
      throw Error(`Error fetching form fields: ${error}`);
    });
};
